<template>
    <div class="conss">
        <div class="bak" @click="goback">←返回</div>
        <div style="background-color: #fff;margin-top: 16px;box-sizing: border-box;padding: 30px;">
            <div class="aotitle">
                订单状态
            </div>
            <div class="par1">
                <div class="patItem flx alc">
                    <div class="parleft">
                        订单状态:
                    </div>
                    <div class="parright" v-text="info.order_status_text"></div>
                </div>

                <div class="patItem flx alc" style="margin: 20px 0;">
                    <div class="parleft">
                        订单编号:
                    </div>
                    <div class="parright" v-text="info.activity_order_no"></div>
                </div>

                <div class="patItem flx alc">
                    <div class="parleft">
                        创建时间:
                    </div>
                    <div class="parright" v-text="info.activity_createtime_text"></div>
                </div>
            </div>
            <div class="aotitle">
                活动信息
            </div>
            <div class="par2 flx alc">
                <div class="parimg">
                    <img :src="$img(info.activity_avatar)" alt="" />
                </div>
                <div class="parinfo">
                    <div class="parname" v-text="info.activity_name">

                    </div>
                    <div class="infItem flx alc">
                        <img :src="$Localimg('id1.png')" alt="" />
                        <span v-text="info.activity_time"></span>
                    </div>

                    <div class="infItem flx alc">
                        <img :src="$Localimg('id2.png')" alt="" />
                        <span v-text="`${info.address}`"></span>
                    </div>
                </div>
            </div>
            <div class="aotitle">
                报名人信息
            </div>
            <div class="par3">
                <div class="parite">
                    <div class="prtleft">
                        姓名
                    </div>
                    <div class="prtright" v-text="info.name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        手机号
                    </div>
                    <div class="prtright" v-text="info.tel">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        邮箱
                    </div>
                    <div class="prtright" v-text="info.email">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        企业名称
                    </div>
                    <div class="prtright" v-text="info.company_name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        岗位职务
                    </div>
                    <div class="prtright" v-text="info.position_name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        行业类型
                    </div>
                    <div class="prtright" v-text="info.industry_name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        所在地区
                    </div>
                    <div class="prtright" v-text="info.address">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        需求
                    </div>
                    <div class="prtright"
                        v-text="info.demand?info.demand : ''">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        身份验证
                    </div>
                    <div class="prtright">
                        <img :src="$img(info.id_img)" alt="" />
                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        推荐人姓名
                    </div>
                    <div class="prtright" v-text="info.promoter">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        微信
                    </div>
                    <div class="prtright" v-text="info.wx_number">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        QQ
                    </div>
                    <div class="prtright" v-text="info.qq">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        学历
                    </div>
                    <div class="prtright" v-text="info.ed">

                    </div>
                </div>
            </div>
            <div class="prices">
                <div class="priceItem flx alc">
                    <div class="pricename" v-text="info.order_status == 0?'需付款':'已付款'"></div>
                    <div class="priceVal" style="font-weight: bold;font-size: 18px;" v-text="`￥${info.total_price}`">
            
                    </div>
                </div>
            </div>
            <div class="btns" style="display: flex;justify-content: flex-end;margin-top: 20px;">
                  <el-button @click="dialogVisible = true">退款</el-button>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="20%">
            <span>确认为该顾客退款?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="refunds">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        aorderdetail,
        refundmoney
    } from "@/api/index.js"
    export default {
        name: 'OrderDetail',
        data() {
            return {
                info: {},
                showALert:false,
                dialogVisible:false
            }
        },
        mounted() {
            this.getDetail()
        },
        methods: {
            refunds(e) {
                let that = this
                let data = that.$route.query.id
                refundmoney(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            goback(){
                history.go(-1)
            },
            getDetail() {
                let that = this
                let data = that.$route.query.id
                aorderdetail(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.info = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .pricename {
        font-size: 14px;
        color: #666666;
    
    }
    .bak{
        font-size: 18px;
        color: #999;
        cursor: pointer;
    }
    .priceVal {
        width: 93px;
        font-size: 14px;
        color: #FF0F23;
        line-height: 21px;
        text-align: right;
    }
    
    .priceItem {
        justify-content: flex-end;
        margin-top: 30px;
    }
    
    .parite {
        display: flex;
        align-items: center;
        margin-bottom: 36px;
    }

    .prtleft {
        width: 385px;
        text-align: right;
        margin-right: 16px;
        font-size: 14px;
        color: #48576A;
        
    }

    .prtright {
        font-size: 14px;
        color: #141933;
    }

    .prtright img {
        width: 516px;
        height: 252px;
        border-radius: 4px 4px 4px 4px;
        object-fit: cover;
    }

    .infItem {
        font-size: 14px;
        color: #1F2937;
        margin-top: 12px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .parname {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #141933;
    }

    .parimg {
        width: 172px;
        height: 100px;
        margin-right: 16px;
    }

    .parimg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: cover;
    }

    .par2 {
        box-sizing: border-box;
        padding: 30px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 50px;
    }

    .parleft {
        font-size: 14px;
        color: #48576A;
        margin-right: 20px;
    }

    .parright {
        font-weight: 600;
        font-size: 14px;
        color: #141933;
    }

    .par1 {
        width: 100%;
        box-sizing: border-box;
        padding: 30px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 50px;
    }

    .aotitle {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-bottom: 22px;
    }

    .conss {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px 0;
        text-align: left;
    }
</style>